import React, {Component} from 'react';
import ferdigLyd from '../../assets/sounds/no/intros/testen-er-ferdig.mp3';
import ferdigLydDe from '../../assets/sounds/de/intros/testen-er-ferdig.wav';
import ferdigLydDeChild from '../../assets/sounds/de/intros/testen-ferdig-child.mp3';
import ferdigLydDeAdult from '../../assets/sounds/de/intros/FOL-A-108.flac';

import AudioPlayer from '../../components/AudioPlayer';

import './styles.scss';
import strings from '../../strings';

class TestComplete extends Component {
	constructor(props) {
		super(props);
		switch (strings.getLanguage()) {
			case 'nn':
				this.finalSound = ferdigLyd;
				break;
			case 'no':
				this.finalSound = ferdigLyd;
				break;
			case 'se':
				this.finalSound = ferdigLyd;
				break;
			case 'de':
				switch (this.props.testKeyType) {
					case 'child-followup':
						this.finalSound = ferdigLydDeChild;
						this.finishText = strings.TestCompleteSalutation;
						break;
					case 'adult-followup':
						this.finalSound = ferdigLydDeAdult;
						this.finishText =
							strings.TesFinished_Instruction_ONCANDIATESIDE_ADULT;
						break;
					default:
						this.finishText =
							strings.TesFinished_Instruction_ONCANDIATESIDE;
						this.finalSound = ferdigLydDe;
						break;
				}

				break;
			default:
				this.finalSound = ferdigLyd;
				break;
		}

		this.state = {};
	}

	render() {
		const isCandidate = this.props.isCandidate || false;
		const isAdultFollowup =
			this.props.testKeyType === 'adult-followup' ? true : false;

		return (
			<div className="TestComplete">
				<h2>
					{isCandidate && (
						<AudioPlayer autoplay inline src={this.finalSound} />
					)}
					{isCandidate
						? this.finishText
						: isAdultFollowup && !isCandidate
							? strings.testIsFinishedAdult
							: strings.testIsFinished}
				</h2>
				<p>
					{isCandidate && strings.getLanguage() === 'de'
						? ''
						: strings.testFinishedInstruction}
				</p>
				<button
					onClick={() => {
						window.localStorage.removeItem('authtoken-child');
						setTimeout(function () {
							window.location = '/';
						});
					}}
				>
					{strings.closeTest}
				</button>
			</div>
		);
	}
}

export default TestComplete;
